import { FC, useMemo } from 'react';
import { faArrowDownRight } from '@fortawesome/pro-regular-svg-icons/faArrowDownRight';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { Badge, BadgeProps, Icon } from '@kontentino/ui';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import NumberUtil from 'utils/number';

interface ReportComparisonBadgeProps {
  percentage: number;
  showIcon?: boolean;
}

const ReportComparisonBadge: FC<ReportComparisonBadgeProps> = ({
  percentage,
  showIcon = true,
}) => {
  const displayedPercentage = Number(percentage.toFixed(2)) || 0;

  const { variant, icon } = useMemo<{
    variant: BadgeProps['variant'];
    icon: IconDefinition | null;
  }>(() => {
    switch (Math.sign(displayedPercentage) as 0 | 1 | -1) {
      case 1:
        return { variant: 'success', icon: faArrowUpRight };
      case -1:
        return { variant: 'destructive', icon: faArrowDownRight };
      case 0:
        return { variant: 'gray', icon: null };
    }
  }, [displayedPercentage]);

  const label = `${
    Math.sign(displayedPercentage) === 1 ? '+' : ''
  }${NumberUtil.compact(displayedPercentage)}%`;

  return (
    <Badge variant={variant}>
      {showIcon && icon && <Icon icon={icon} size={12} />}
      {label}
    </Badge>
  );
};

export default ReportComparisonBadge;
